"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InActiveDot = exports.Dot = void 0;
const react_1 = __importDefault(require("react"));
const native_1 = require("styled-components/native");
const S = __importStar(require("./Dot.styles"));
exports.Dot = ({ index, activeIndex, onDotPress, activeColor, enabledDotPress = false, inActiveColor, }) => {
    const theme = native_1.useTheme();
    return (react_1.default.createElement(S.Dot, { disabled: !enabledDotPress, style: index === activeIndex
            ? { backgroundColor: activeColor || theme.bpCore.colors.link }
            : {
                backgroundColor: inActiveColor || theme.bpCore.colors.white,
                borderWidth: 1,
                borderColor: '#d8d8d8',
            }, testID: `dot_${index}`, onPress: () => onDotPress(index) }));
};
exports.InActiveDot = ({ index, onDotPress, enabledDotPress = false, inActiveColor, }) => {
    const theme = native_1.useTheme();
    return (react_1.default.createElement(S.Dot, { disabled: !enabledDotPress, style: {
            backgroundColor: inActiveColor || theme.bpCore.colors.white,
            borderWidth: 1,
            borderColor: '#d8d8d8',
        }, testID: `dot_${index}`, onPress: () => onDotPress(index) }));
};
